import React from 'react'
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import './Skeleton.css'


const SkeletonLoading = () => {
    return (
        // <SkeletonTheme baseColor="#2c2c2c" highlightColor="gray"
        //     width={"100%"}
        //     height={"80vh"}
        // >
        //     <p>
        //         <Skeleton width={"100%"} height={"80vh"} borderRadius={16} duration={3} />
        //     </p>
        // </SkeletonTheme>
        <div className="w-[100%] h-[100%] animate-pulse relative">
            {/* Full Image Background */}
            <div className="h-[100%] w-[100%] bg-gray-800 SkeletonLoading_carousal_div01"></div>
            {/* Content Overlay */}
            <div className="absolute bottom-0 left-0 w-full px-8 pb-8">
                {/* Share Icon */}
                <div className="h-[30px] w-[30px] bg-gray-600 rounded-full absolute top-[-60px] right-[10px]"></div>
                {/* Title */}
                <div className="h-[64px] bg-gray-600 rounded mb-4 max-w-[600px]"></div>
                {/* Location, Date, Time + Button Row */}
                <div className='w-[100%] flex gap-3 items-center flex-wrap'>
                    <div className="h-[40px] bg-gray-600 rounded-full px-4 w-[150px]"></div>
                    <div className="h-[40px] bg-gray-600 rounded-full px-4 w-[150px]"></div>
                    <div className="h-[40px] bg-gray-600 rounded-full px-4 w-[120px]"></div>
                    <div className="h-[40px] bg-red-600 rounded-full flex-1 min-w-[200px]"></div>
                </div>
                {/* Pagination Dots */}
                <div className='w-[100%] flex gap-2 justify-end mt-4'>
                    <div className="h-[14px] bg-gray-600 w-[14px] rounded-full"></div>
                    <div className="h-[14px] bg-gray-600 w-[14px] rounded-full"></div>
                    <div className="h-[14px] bg-gray-600 w-[14px] rounded-full"></div>
                </div>
            </div>
        </div>
    )
}

export default SkeletonLoading
